<template>
  <single-panel-page
    class="event-page"
    img-src="/static/img/wolves-summit-logo.png"
  >
    <div v-show="!magicLinkSent">
      <div class="alert-default">
        <p>Please fill in your e-mail address</p>
      </div>

      <div v-show="hasErrors" class="alert alert-danger alert-nobg text-left">
        Wrong e-mail address
      </div>

      <form>
        <input
          v-model="email"
          class="form-control email-field"
          autofocus
          placeholder="E-mail"
          @keydown.enter="submit()"
        />

        <br />

        <button
          class="btn btn-primary"
          :class="{ 'animated pulse': clicked }"
          :disabled="inProgress"
          type="submit"
          @click.prevent="submit()"
        >
          <loader v-show="inProgress" class="loader-xs" />
          Submit
        </button>
      </form>
    </div>

    <div v-show="magicLinkSent" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-info">
          We have sent you a link with account access information.
        </p>
      </div>
    </div>

    <div slot="bottom" class="hidden">
      <span class="splash-box-footer">
        <router-link :to="{ name: 'eventPagePasscode', slug: slug }" href=""
          >I have a passcode</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Promise from 'bluebird'
import Auth from 'services/Auth'
import delayRequest from 'utils/delay-request'

export default {
  data: function () {
    return {
      email: '',
      inProgress: false,
      clicked: false,
      errors: { email: [] },
      magicLinkSent: false,
    }
  },
  computed: {
    slug() {
      return this.$router.currentRoute.params.slug
    },
    hasErrors() {
      return this.errors.email.length > 0
    },
  },
  created() {
    const self = this
    const providedPasscode = self.$route.query.passcode
    if (providedPasscode) {
      this.$router.push({
        name: 'eventPagePasscode',
        slug: this.slug,
        query: {
          passcode: providedPasscode,
          user_id: self.$route.query.user_id,
        },
      })
      // re-route to passcode subpage
    }
  },
  methods: {
    submit() {
      const self = this
      self.inProgress = true
      let request = Auth.sendMagicLink(self.email)
      request = Promise.delay(500).return(request)
      request
        .then((response) => {
          self.inProgress = false
          self.magicLinkSent = true
          self.errors = { email: [] }
        })
        .catch((res) => {
          console.log(' => ERRORED')
          Object.assign(self.errors, res.response.data)
          self.inProgress = false
        })
    },
  },
}
</script>

<style lang="scss">
.event-page {
  .email-field {
    font-size: 22px;
  }
}
</style>
